export default "__VITE_ASSET__BRLKqflQ__"